export default __webpack_public_path__ + "static/media/taxactindia.6c72dbb6.png";